var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"reason-card"},[_c('h3',[_vm._v("Motivo Detalhado:")]),_c('ul',_vm._l((_vm.reasons),function(reason,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(reason)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }